<section
  class="sticky top-0 w-full z-50 navbarTop pb-8"
  #pygNavigation
  [class.pygBgActive]="pygBgActive()"
  [@navAnime]="navAnimeTrigger()"
  [@navBlogAnime]="navBlogAnimeTrigger()"
>
  <div class="max-w-screen-2xl mx-auto">
    <div
      class="w-10/12 sm:w-9/12 mx-auto flex flex-nowrap justify-between relative"
      [@navWidthAnime]="navigationWidth()"
    >
      <img
        [src]="
          pygBgActive()
            ? 'assets/img/Shared/pygmalios-logo-white.svg'
            : 'assets/img/Shared/pygmalios-logo.svg'
        "
        class="w-40 sm:w-44 md:w-48 lg:w-52 outline-hidden cursor-pointer"
        [routerLink]="langPath()"
        (click)="toElement('instore')"
      />
      <div class="flex">
        <div class="pt-1 lg:flex lg:ml-3 xl:ml-6 hidden my-auto">
          <div
            class="cursor-pointer ml-3 xl:ml-5"
            [routerLink]="langPath()"
            (click)="toElement('industry')"
          >
            <p
              [class.active]="activeSiteSection() | sectionActive: 'industry'"
              [class.inactiveProducts]="productsIsActive()"
            >
              {{ "navigation.industries" | translate }}
            </p>
            @if (
              (activeSiteSection() | sectionActive: "industry") && !navChange()
            ) {
              <hr [@hrAnime] />
            }
          </div>

          <div
            class="ml-4 pl-1 pygDropdown pygProducts hidden lg:block relative my-auto"
          >
            <div class="flex justify-between">
              <p
                [class.active]="
                  activeSiteSection() | sectionActive: ['products', 'shopguard']
                "
                [class.activeProducts]="
                  (activeSiteSection() | sectionActive: 'products') &&
                  !navChange()
                "
              >
                {{ "navigation.products" | translate }}
              </p>
            </div>
            <div class="pygItems hidden absolute bg-white pt-2 -ml-1 pl-1">
              <a [routerLink]="langPath() + 'shopguard'">
                <p
                  [class.active]="
                    activeSiteSection() | sectionActive: 'shopguard'
                  "
                >
                  {{ "navigation.theft_protection" | translate }}
                </p>
              </a>
              <a [routerLink]="langPath() + 'products'">
                <p
                  [class.active]="
                    activeSiteSection() | sectionActive: 'products'
                  "
                >
                  {{ "navigation.in_store" | translate }}
                </p>
              </a>
            </div>
          </div>

          <div
            class="cursor-pointer ml-3 xl:ml-5"
            [routerLink]="langPath() + 'blog'"
          >
            <p
              [class.active]="activeSiteSection() | sectionActive: 'blog'"
              [class.inactiveProducts]="productsIsActive()"
            >
              {{ "navigation.blog" | translate }}
            </p>
            @if (
              (activeSiteSection() | sectionActive: "blog") && !navChange()
            ) {
              <hr [@hrAnime] />
            }
          </div>
        </div>

        <div class="flex">
          @if (activeSiteSection() === "blog" && navChange()) {
            <button
              class="font-bold rounded-l-full rounded-r-full hidden lg:block w-full h-16 lg:h-12 lg:w-40 ml-3 xl:ml-5"
              [@btnAnime]
              (click)="toogleSubscribeForm()"
            >
              {{ "buttons.subscribe" | translate }}
            </button>
          }

          <app-get-demo class="hidden lg:block ml-3 xl:ml-5"></app-get-demo>

          <div class="ml-4 pl-1 pygDropdown hidden lg:block relative my-auto">
            <div class="flex justify-between">
              <p class="active">{{ activeLanguage() }}</p>
              <img
                src="assets/img/Shared/chevron.svg"
                alt=""
                class="chevron mr-3 mt-0.5"
              />
            </div>
            <div class="pygItems hidden absolute bg-white -ml-1 pl-1">
              @for (lang of languages; track lang) {
                <div
                  class="flex justify-between cursor-pointer"
                  (click)="setLanguage(lang)"
                >
                  @if (activeLanguage() !== lang) {
                    <p>
                      {{ lang }}
                    </p>
                  }
                  @if (activeLanguage() !== lang) {
                    <img
                      src="assets/img/Flags/{{ lang }}.svg"
                      alt=""
                      class="w-5 h-4 mr-3 my-auto border"
                    />
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <img
        [src]="`assets/img/Shared/${menuImg()}`"
        alt="Menu"
        class="block lg:hidden cursor-pointer p-5 -mr-5"
        (click)="openMenu()"
      />

      @if (subscribeOpened()) {
        <div class="pygPopup" (clickOutside)="focusOut()" [@menuAnime]>
          <app-popup-subscribe
            [place]="'blog navigation'"
          ></app-popup-subscribe>
        </div>
      }
    </div>
  </div>

  @if (menuOpen()) {
    <div
      class="w-10/12 sm:w-9/12 mx-auto"
      (click)="hideMenu()"
      [@menuAnime]="menuOpen()"
    >
      <div
        class="flex justify-between cursor-pointer"
        [routerLink]="langPath()"
        (click)="toElement('industry')"
      >
        <p
          class="p-3 my-3 -ml-2"
          [class.active]="activeSiteSection() | sectionActive: 'industry'"
          [class.inactiveProducts]="productsIsActive()"
        >
          {{ "navigation.industries" | translate }}
        </p>
        <img src="assets/img/Shared/arrow-right.svg" alt="arrow" />
      </div>
      <hr />
      <div class="pb-3">
        <p
          class="p-3 mt-3 mb-2 -ml-2"
          [class.active]="
            activeSiteSection() | sectionActive: ['products', 'shopguard']
          "
        >
          {{ "navigation.products" | translate }}
        </p>
        <a
          class="flex justify-between ml-4"
          [routerLink]="langPath() + 'shopguard'"
        >
          <p [class.active]="activeSiteSection() | sectionActive: 'shopguard'">
            {{ "navigation.theft_protection" | translate }}
          </p>
          <img src="assets/img/Shared/arrow-right.svg" alt="arrow" />
        </a>
        <a
          class="flex justify-between ml-4"
          [routerLink]="langPath() + 'products'"
        >
          <p [class.active]="activeSiteSection() | sectionActive: 'products'">
            {{ "navigation.in_store" | translate }}
          </p>
          <img src="assets/img/Shared/arrow-right.svg" alt="arrow" />
        </a>
      </div>
      <hr />
      <div
        class="flex justify-between cursor-pointer"
        [routerLink]="langPath() + 'blog'"
      >
        <p
          class="p-3 my-3 -ml-2"
          [class.active]="activeSiteSection() | sectionActive: 'blog'"
          [class.inactiveProducts]="productsIsActive()"
        >
          {{ "navigation.blog" | translate }}
        </p>
        <img
          style="color: white"
          src="assets/img/Shared/arrow-right.svg"
          alt="arrow"
        />
      </div>
      <hr />
      <div class="pygLanguages lg:hidden flex max-w-md -ml-2 my-3">
        @for (lang of languages; track lang) {
          <div class="cursor-pointer mr-4" (click)="setLanguage(lang)">
            <p [class.active]="activeLanguage() === lang">
              {{ lang }}
            </p>
            <img
              src="assets/img/Flags/{{ lang }}.svg"
              alt=""
              class="w-5 h-4 ml-2 border"
            />
          </div>
        }
      </div>
    </div>
  }
</section>
